export enum FilterValueInputType {
  STRING = 'String',
  SELECT = 'Select',
  AUTOCOMPLETE = 'Autocomplete',
  DATE_TIME = 'DateTime',
  TIMESTAMP = 'Timestamp',
}
